module.exports = __webpack_public_path__ + "static/media/male_right_grey.5c884133.png";